import React, { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import { RouterProvider } from 'react-router-dom';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
// import router from 'routes';
import Router from 'routes';
import { getFbclid, getOrGenerateFbp, setFbclid, setFbp, setFbUUID } from 'helpers';
import './App.scss';
import './styles/main.scss';
import { APP_INFO, ENV, IS_PROD, SHOW_LOGS } from './config';
import themeConfig, { themeAdditionalConfig } from './theme';
import LoggerComponent from './components/Logger/Logger.component';

if (SHOW_LOGS) {
  console.info('APP_INFO', APP_INFO);
  console.info('ENV', ENV);
  console.info('IS_PROD', IS_PROD);
}

const App = (): JSX.Element => {
  const theme = createTheme(themeConfig, {
    ...themeAdditionalConfig,
  });

  const queryParams = new URLSearchParams(window.location.search);
  const fbclid = queryParams.get('fbclid');

  useEffect(() => {
    if (fbclid && fbclid !== getFbclid()) {
      setFbclid(fbclid);
      setFbp(getOrGenerateFbp());
      setFbUUID(uuidv4());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fbclid]);

  return (
    // <React.StrictMode>

    <ThemeProvider theme={theme}>
      <Container
        style={{
          minWidth: '100%',
          height: '100%',
          maxHeight: '100%',
          padding: 0,
          margin: 0,
        }}
      >
        <div className="MainWrapper">
          {/* <RouterProvider router={router} /> */}
          <Router />
        </div>
      </Container>
      <LoggerComponent />
    </ThemeProvider>

    // </React.StrictMode>
  );
};

export default App;
